import { useSyncExternalStore } from "react";
import { useImpersonationBannerVisible } from "./ImpersonationBanner";
import {
  isActAsFrameEnabled,
  subscribeActAsFrame,
} from "../../../../contexts/actAsFrameStore";

// Fullscreen, click-through orange frame while an admin is acting as a vendor —
// the screen-share-style "you are in someone else's seat" signal. The banner
// (ImpersonationBanner) carries the text and the exit action; this frame is the
// peripheral glow that stays in view on every screen, including dialogs and the
// design editor, so the impersonation state can never be overlooked.
//
// pointer-events-none: purely visual, must never intercept a click.
// z-[10001]: one above the highest overlay in the app (NavigationBar's
// z-[10000] fullscreen overlay); MUI dialogs (~1300) and toasts stay below,
// which is intentional — the frame marks the WHOLE session, dialogs included.
// The base shadow class is what reduced-motion users see (motion-reduce turns
// the breathing animation off; animations otherwise override the class shadow).
export function ImpersonationFrame() {
  const visible = useImpersonationBannerVisible();
  // Admin-menu preference: the frame can be switched off (LoggedInMenu) so
  // the app behaves exactly as before the frame existed.
  const frameEnabled = useSyncExternalStore(
    subscribeActAsFrame,
    isActAsFrameEnabled
  );

  if (!visible || !frameEnabled) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      data-testid="impersonation-frame"
      className={
        "pointer-events-none fixed inset-0 z-[10001] " +
        "shadow-[inset_0_0_0_3px_rgba(245,158,11,0.75),inset_0_0_22px_6px_rgba(245,158,11,0.25)] " +
        "animate-actAsFrame motion-reduce:animate-none"
      }
    />
  );
}
